import { useEffect, useRef } from 'react';
import { Radio, Zap, Activity, TrendingUp, ClipboardList, Key, Gauge, Percent, BarChart3, Waves, Compass, LayoutDashboard, Crosshair } from 'lucide-react';
var tabs = [
  { id: 'dashboard', label: 'Home', Icon: LayoutDashboard },
  { id: 'jpsignal', label: 'Signal', Icon: Radio },
  { id: 'quantiply', label: 'Quantiply', Icon: Zap },
  { id: 'amb', label: 'AMB', Icon: Activity },
  { id: 'amb2', label: 'AMB2', Icon: Activity },
  { id: 'amb3', label: 'AMB3', Icon: Activity },
  { id: 'super_straddle', label: 'SS1', Icon: Activity },
  { id: 'super_straddle_2', label: 'SS2', Icon: Activity },
  { id: 'super_straddle_3', label: 'SS3', Icon: Activity },
  { id: 'hybrid', label: 'Hybrid', Icon: Gauge },
  { id: 'gex', label: 'GEX', Icon: BarChart3 },
  { id: 'positioning', label: 'Position', Icon: BarChart3 },
  { id: 'oiride', label: 'Ride', Icon: TrendingUp },
  { id: 'oirided', label: 'RideD', Icon: TrendingUp },
  { id: 'oirided1', label: 'RideD1', Icon: TrendingUp },
  { id: 'oirider', label: 'RideR', Icon: TrendingUp },
  { id: 'oiwalls', label: 'Walls', Icon: BarChart3 },
  { id: 'oiwalls3x', label: 'Walls3x', Icon: BarChart3 },
  { id: 'oiwalls2x', label: 'Walls2X', Icon: BarChart3 },
  { id: 'oiwalls_live', label: 'W-LIVE', Icon: BarChart3 },
  { id: 'oiwalls3x_live', label: 'W3x-LIVE', Icon: BarChart3 },
  { id: 'gexwalls_live', label: 'G-LIVE', Icon: Crosshair },
{ id: 'oiride_d_live', label: 'OIRideD L', Icon: Crosshair },
{ id: 'oiride_r_live', label: 'OIRideR L', Icon: Crosshair },
{ id: 'directional_tv', label: 'DirTV', Icon: TrendingUp },
{ id: 'directional_tv1', label: 'DirTV1', Icon: TrendingUp },
  { id: 'gexwalls', label: 'GWalls', Icon: Crosshair },
  { id: 'straddle', label: 'Strad', Icon: Waves },
  { id: 'orders', label: 'Orders', Icon: ClipboardList },
  { id: 'token', label: 'Token', Icon: Key },
];

// Nav visibility arrives as a PROP from App, which owns the single fetch.
// Each of these components used to run its own copy of the hook — four
// independent fetches, four pieces of state — so the bottom bar and the swipe
// order could settle on different lists depending on which response landed
// first. One source of truth removes the race entirely.

export default function MobileNav({ activePage, setActivePage, hidden }) {
  // The bar scrolls horizontally, but swiping between pages changes activePage
  // without touching it — so the highlighted tab could sit off-screen with no
  // way to know where you are. Scroll the active tab into view whenever it
  // changes, from a swipe or a tap.
  var barRef = useRef(null);
  var tabRefs = useRef({});
  useEffect(function () {
    var el = tabRefs.current[activePage];
    var bar = barRef.current;
    if (!el || !bar) return;
    // Centre it rather than just nudging it to an edge, so the neighbouring
    // tabs are visible too and you can see where a swipe would land next.
    var target = el.offsetLeft - (bar.clientWidth / 2) + (el.offsetWidth / 2);
    var max = bar.scrollWidth - bar.clientWidth;
    if (max <= 0) return;                       // nothing to scroll
    var to = Math.max(0, Math.min(target, max));
    if (bar.scrollTo) {
      bar.scrollTo({ left: to, behavior: 'smooth' });
    } else {
      bar.scrollLeft = to;
    }
  }, [activePage]);
  hidden = hidden || [];
  // Fail-safe: this bar has no Settings tab, so an empty strip would leave no
  // way to navigate. Falling back to the full set keeps the app usable.
  var shown = tabs.filter(function (t) { return hidden.indexOf(t.id) === -1; });
  if (!shown.length) shown = tabs;
  return (
    <div style={{ position:'fixed', bottom:0, left:0, right:0, background:'#080e1d', borderTop:'1px solid rgba(26,45,74,0.4)', zIndex:100, paddingBottom:'env(safe-area-inset-bottom,0)' }}>
      <div ref={barRef} style={{ display:'flex', overflowX:'auto', WebkitOverflowScrolling:'touch', scrollbarWidth:'none', msOverflowStyle:'none' }}>
        {shown.map(function(t) {
          var active = activePage === t.id;
          return (
            <div key={t.id} ref={function (el) { tabRefs.current[t.id] = el; }}
              onClick={function() { setActivePage(t.id); }}
              style={{ flex:'0 0 auto', minWidth:64, display:'flex', flexDirection:'column', alignItems:'center', padding:'8px 12px 6px', cursor:'pointer', opacity:active ? 1 : 0.4 }}>
              <t.Icon size={18} color={active ? '#0ea5e9' : '#8899aa'} />
              <span style={{ fontSize:9, fontWeight:700, color:active ? '#0ea5e9' : '#8899aa', marginTop:2, whiteSpace:'nowrap' }}>{t.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
